/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selected_Events_OnlyInputs */



/**
* | output |
* | --- |
* | "Selected events only" |
*
* @param {Selected_Events_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const selected_events_only = /** @type {((inputs?: Selected_Events_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_Events_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements sélectionnés uniquement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur ausgewählte Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Только выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("仅选定的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントのみ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल चयनित इवेंट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Apenas eventos selecionados")
	return /** @type {LocalizedString} */ ("Selected events only")
});